import type { JSX } from 'react';
import type { ConnectionState } from '../lib/useSessionStream';
import { Pill, type Tone } from './ui';

const LABELS: Record<ConnectionState, string> = {
  connecting: 'Verbinde …',
  open: 'Live',
  closed: 'Getrennt',
};

const TONES: Record<ConnectionState, Tone> = {
  connecting: 'warning',
  open: 'success',
  closed: 'danger',
};

export function ConnectionIndicator({ state }: { state: ConnectionState }): JSX.Element {
  return (
    <Pill
      tone={TONES[state]}
      pulsing={state !== 'open'}
      title={
        state === 'closed'
          ? 'Statusverbindung getrennt — es wird erneut versucht. Die Anzeige kann veraltet sein.'
          : 'Statusverbindung zur Control Plane (WebSocket)'
      }
    >
      {LABELS[state]}
    </Pill>
  );
}
